module.exports = "<div class=\"row icon-fb\">\n        <button mat-raised-button class=\"fa fa-facebook\"></button>\n</div>"